import styled from 'styled-components';
import { withLinkUnderlined } from 'app/theme';

/* eslint-disable-next-line */
export const LegalInfoListItem = styled.li.attrs({
  className: 'l-legal-info__item'
})`
  width: 100%;

  .l-legal-info__link {
    word-break: break-all;
    color: #de1619;
    ${withLinkUnderlined};
  }

  .l-legal-info__item-text {
    display: inline-block;
    margin-right: 5px;
    text-transform: capitalize;
  }

  & + & {
    margin-top: 12px;
  }
`;
